import {
  parseSearchNumberValue,
  parseSearchStringValue,
} from 'infrastructure/functions/parse-query-string';
import { type TCareManagersFilter } from 'infrastructure/hooks/agency-doctor';
import { useQueryFilterNew } from 'infrastructure/hooks/common/use-query-param-new';

import type { TParseFunctions } from 'infrastructure/hooks/common/use-query-param-new';

const defaultFilter: TCareManagersFilter = {
  page: 1,
};

const parseFunctions: TParseFunctions<TCareManagersFilter> = {
  page: parseSearchNumberValue,
  fullName: parseSearchStringValue,
  minPatientsAssigned: parseSearchNumberValue,
  maxPatientsAssigned: parseSearchNumberValue,
  clinicalRoles: parseSearchStringValue,
  sortBy: parseSearchStringValue,
  sortDirection: parseSearchStringValue,
};

export const useCareManagersFilter = () => {
  return useQueryFilterNew<TCareManagersFilter>(defaultFilter, parseFunctions, [
    'sortBy',
    'sortDirection',
  ]);
};
